import Tel1Summary from "./summary";
function Tel1Overall({ overAllData = [] }) {
  return (
    <>
      <div className="mb-3">
        <div>Peringkat program secara keseluruhan</div>
        <div className="d-flex mt-1 text-inverse text-opacity-50">
          <div className="row ps-3">
            {overAllData.length > 0
              ? overAllData.map((v, i) => (
                  <div key={i} className="col-2">
                    <div>
                      {v.rate}: <span className={v.qty > 0 ? "text-danger" : "text-opacity-50"}>{v.qty}</span>
                    </div>
                  </div>
                ))
              : ""}
          </div>
        </div>
      </div>
    </>
  );
}

export default Tel1Overall;
